
import { IMaskComponent } from 'vue-imask';
import VueTypes from 'vue-types';
import { mapMutations } from 'vuex';

export default {
    name: 'EcomMyInput',
    components: {
        'imask-input': IMaskComponent
    },
    data() {
        return {
            passType: true
        };
    },
    props: {
        name: VueTypes.oneOfType([String, Number]).def(''),
        value: VueTypes.oneOfType([String, Object, Number]).def(''),
        type: VueTypes.string.def('text'),
        errorText: VueTypes.oneOfType([String, Array]).def('error'),
        placeholder: VueTypes.oneOfType([String, Number]).def(''),
        label: VueTypes.string.def(''),
        labelStar: VueTypes.bool.def(false),
        isValid: VueTypes.bool.def(false),
        inputClasses: VueTypes.array.def([])
    },
    methods: {
        updateInput(e) {
            this.$emit('input', e.target.value);
        }
    },
    computed: {
        getErrorText() {
            if (typeof this.errorText === 'string') {
                return this.errorText;
            } else {
                return this.errorText.join(' ');
            }
        }
    }
};
